export enum ForcedCase {
    NONE = "none",
    UPPER = "upper",
    LOWER = "lower"
}